var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _rect, _path11, _path12, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCustom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.75 60.1367H60.75V0.136719H0.75V60.1367Z",
    fill: "white",
    fillOpacity: 0.01
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.45801 48.0462H37.7356C40.1491 48.0462 42.1058 46.0939 42.1058 43.676V15.9148L27.2491 1.03125H11.8282C9.41472 1.03125 7.45801 2.98349 7.45801 5.4014V48.0462Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.45801 48.0462H37.7356C40.1491 48.0462 42.1058 46.0939 42.1058 43.676V15.9148L27.2491 1.03125H11.8282C9.41472 1.03125 7.45801 2.98349 7.45801 5.4014V48.0462Z",
    stroke: "url(#paint0_linear_901_3498)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.0968 15.879H31.6192C29.2057 15.879 27.249 13.9268 27.249 11.5089V1.03125L42.0968 15.879Z",
    fill: "url(#paint1_linear_901_3498)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.0968 15.879H31.6192C29.2057 15.879 27.249 13.9268 27.249 11.5089V1.03125L42.0968 15.879Z",
    stroke: "url(#paint2_linear_901_3498)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.45743 5.98438H6.87534C4.47893 6.00229 2.54549 7.94557 2.54102 10.3456V48.6292C2.55534 51.0202 4.48609 52.9545 6.87534 52.9724H32.7828C33.9416 52.9724 35.0538 52.5157 35.8733 51.6918C36.6927 50.8769 37.153 49.7575 37.153 48.6023V48.0471H11.8276C9.41415 48.0471 7.45743 46.0948 7.45743 43.6769V5.98438Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.45743 5.98438H6.87534C4.47893 6.00229 2.54549 7.94557 2.54102 10.3456V48.6292C2.55534 51.0202 4.48609 52.9545 6.87534 52.9724H32.7828C33.9416 52.9724 35.0538 52.5157 35.8733 51.6918C36.6927 50.8769 37.153 49.7575 37.153 48.6023V48.0471H11.8276C9.41415 48.0471 7.45743 46.0948 7.45743 43.6769V5.98438Z",
    stroke: "url(#paint3_linear_901_3498)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8281 29.0884H25.0102",
    stroke: "url(#paint4_linear_901_3498)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8281 21.3345H30.4998",
    stroke: "url(#paint5_linear_901_3498)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8281 25.2095H30.4998",
    stroke: "url(#paint6_linear_901_3498)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.01,
    x: 21.4961,
    y: 28.1367,
    width: 32,
    height: 32,
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.3446 29.5509C46.1256 28.7699 47.392 28.7699 48.173 29.5509L52.0814 33.4593C52.8625 34.2404 52.8625 35.5067 52.0814 36.2878L32.1867 56.1825C31.8116 56.5576 31.3029 56.7683 30.7725 56.7683L24.8641 56.7683L24.8641 50.8599C24.8641 50.3294 25.0748 49.8207 25.4498 49.4457L45.3446 29.5509Z",
    fill: "url(#paint7_linear_901_3498)",
    stroke: "url(#paint8_linear_901_3498)",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M41.707 33.1894L48.4439 39.9262",
    stroke: "url(#paint9_linear_901_3498)",
    strokeWidth: 1.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_901_3498",
    x1: 24.7819,
    y1: 1.03125,
    x2: 24.7819,
    y2: 48.0462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#084277"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#1E6E90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_901_3498",
    x1: 34.6729,
    y1: 1.03125,
    x2: 34.6729,
    y2: 15.879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#084277"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#1E6E90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_901_3498",
    x1: 34.6729,
    y1: 1.03125,
    x2: 34.6729,
    y2: 15.879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#084277"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#1E6E90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_901_3498",
    x1: 19.847,
    y1: 5.98437,
    x2: 19.847,
    y2: 52.9724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#084277"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#1E6E90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_901_3498",
    x1: 18.4192,
    y1: 28.6406,
    x2: 18.4192,
    y2: 29.5361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#084277"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#1E6E90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_901_3498",
    x1: 21.1639,
    y1: 20.8867,
    x2: 21.1639,
    y2: 21.7822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#084277"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#1E6E90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_901_3498",
    x1: 21.1639,
    y1: 24.7617,
    x2: 21.1639,
    y2: 25.6572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#084277"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#1E6E90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_901_3498",
    x1: 50.1272,
    y1: 31.5051,
    x2: 24.8641,
    y2: 56.7683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#084277"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#1E6E90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_901_3498",
    x1: 50.1272,
    y1: 31.5051,
    x2: 24.8641,
    y2: 56.7683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#084277"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#1E6E90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_901_3498",
    x1: 45.0755,
    y1: 33.1894,
    x2: 45.0755,
    y2: 39.9262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#084277"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#1E6E90"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustom);
export default __webpack_public_path__ + "static/media/Custom.475ea5a5713cceb265974266534f7f63.svg";
export { ForwardRef as ReactComponent };